var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashbordIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.32361V16.25C2.5 17.1705 3.24619 17.9167 4.16667 17.9167H15.8333C16.7538 17.9167 17.5 17.1705 17.5 16.25V8.32361C17.5 7.8045 17.2581 7.31502 16.8457 6.99969L10.7477 2.33644C10.533 2.17227 10.2702 2.08333 10 2.08333C9.72975 2.08333 9.467 2.17227 9.25233 2.33644L3.15425 6.99969C2.74188 7.31503 2.5 7.8045 2.5 8.32361Z",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.9167V12.0833C12.5 11.6231 12.1269 11.25 11.6667 11.25H8.33333C7.8731 11.25 7.5 11.6231 7.5 12.0833V17.9167",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbordIcons);
export default __webpack_public_path__ + "static/media/dashbord-icons.34cc1fd037c9c8d4502f9fd579882c3a.svg";
export { ForwardRef as ReactComponent };